import React from 'react';
import { render } from 'react-dom';
// import Rx from 'rxjs';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/first';

// Velocity
import './components/plugins/velocity.min.js';

// Styles
import 'normalize.css';
import '../scss/main.scss';

// Core & Events
import UmiCore from '../../../UmiCore/src/UmiCore';
import ee from '../../../UmiCore/src/EventDriver';

// Components
import CONFIG from './Config';
const C = CONFIG;
import comIface from './ComIface';
import DynamicStylesTag from './components/dynamic-styles/DynamicStylesTag';
import CSSRules from './components/dynamic-styles/CSSRules';
import GUI from './GUI';
import Background from './components/background/Background';
import Filter from './components/filter/Filter';

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      rendered: false,
      staticUrl: C.staticUrl,
      // soundUrl: C.soundUrl,
      // Colors
      colors: C.colors,
      accent: C.accent,
      dark: C.dark,
      light: C.light,
      contrast: C.contrast,
      header_background: C.header_background,
      // Avatar
      avatar_shape: C.avatar_shape, // circle, rect, none
      avatar_scale: C.avatar_scale,
      avatar_url: C.avatar_url,
      // Fonts
      font: C.font,
      font_size: C.font_size,
      // Content variables
      logo: C.logo,
      brand_name: C.brand_name,
      tagline: C.tagline,
      // Background variables
      background_type: C.background_type, // color, gradient, image, video
      background_image_url: C.background_image_url,
      background_color: C.background_color,
      gradient_from: C.gradient_from,
      gradient_to: C.gradient_to,
      videoname: C.videoname,
      video_url: C.video_url,
      // Filter variables
      filter_type: C.filter_type, // none, color, gradient, image
      filter_color: C.filter_color,
      filter_gradient_from: C.filter_gradient_from,
      filter_gradient_to: C.filter_gradient_to,
      filter_image_url: C.filter_image_url,
      // External
      stylesheets: C.stylesheets,
      // Custom
      style: C.style,
      // Keywords
      keywords: C.keywords,
      persistent_menu: C.persistent_menu,
      // Progress
      progress: C.progress,
      // Test
      test: C.test,
      // Branding
      branding: C.branding,
      // General settings
      typing: C.typing,
      widget_hide_background: C.widget_hide_background,
      widget_hide_header: C.widget_hide_header,
    };
    this.GOOGLE_API_KEY = 'AIzaSyCsJun2zDaXACKwuR-0dJefAhBwIwR5PP8';

    this.setupListeners();
    this.umicore = new UmiCore();
    this.appElem = null;

    window.setGlobalState = this.setGlobalState.bind(this);
    window.ee = ee;
  }

  /**
   * state = {
   *   background_color: red,
   *   ...
   * }
   */
  setGlobalState(state) {
    this.setState(state);
  }

  setupListeners() {
    const umicoreReady$ = Observable.fromEvent(ee, 'hu-umicore-ready');
    const landbotReady$ = Observable.fromEvent(ee, 'hu-landbot-ready');

    const appReady$ = Observable
      .merge(umicoreReady$, landbotReady$)
      .distinctUntilChanged()
      .pairwise()
      .first()
      .subscribe({
        next: (v) => ee.emit('hu-start-connection')
      });
    
    const reception1$ = Observable.fromEvent(ee, 'hu-receive-message');
    const reception2$ = Observable.fromEvent(ee, 'hu-initial-chat');
    
    const hideLoader$ = Observable
      .merge(reception1$, reception2$)
      .first()
      .subscribe({
        next: (v) => this.setState({ isLoading: false })
      });

    ee.on('hu-lb-rendered', () => {
      this.setState({
        rendered: true,
      });
    });

    ee.on('hu-load-config', (config) => {
      this.setState(config);
    });

    ee.on('hu-error-wrong-customer', () => {
      // Manejar error de recepción de firebase token
    });

    ee.on('hu-error-wrong-channel', () => {
      // Manejar error de recepción de firebase token
    });

    ee.on('hu-error-auth-connection', () => {
      // Manejar error de conexión de firebase
    });

    ee.on('hu-error-server-connection', () => {
      // Manejar error de conexión con servidor de Django
    });

    // AUDIO?
    // if (this.state.soundUrl) {
    //   const audio = new Audio(this.state.soundUrl);
    //   ee.on('hu-lb-audio-notification', () => {
    //     audio.play()
    //   });
    // } // Ver además document.activeElement
  }

  componentDidMount() {
    // TESTS ================

    // setInterval(() => {
      // let bools = [true, false];
      // let val0 = bools[Math.floor(Math.random()*bools.length)];
      // let colors1 = ['#FF199F', '#E87F55', '#FFD16A', '#9867E8', '#86BDFF'];
      // let colors2 = ['#6250FF', '#FFAB54', '#78E87B', '#E8A786', '#95FF54'];
      // let val1 = colors1[Math.floor(Math.random()*colors1.length)];
      // let val2 = colors2[Math.floor(Math.random()*colors2.length)];
      // let bgs = ['video', 'image', 'gradient', 'color'];
      // let val3 = bgs[Math.floor(Math.random()*bgs.length)];
      // let bgimgs = [
      //   'https://storage.googleapis.com/media.yexir.com/channels_back/31.png',
      //   'http://pre06.deviantart.net/c55d/th/pre/f/2011/210/3/a/3aac8c61503090b3dae6743dc8d5cd4c-d421d5s.jpg',
      //   'http://img04.deviantart.net/ee5b/i/2009/088/3/c/droideka_by_avaruus_apina.jpg'
      // ];
      // let val4 = bgimgs[Math.floor(Math.random()*bgimgs.length)];
      // let videos = ['video_1', 'video_2', 'video_3', 'video_4'];
      // let val5 = videos[Math.floor(Math.random()*videos.length)];
      // let fil_types = ['color', 'gradient', 'image'];
      // let val6 = fil_types[Math.floor(Math.random()*fil_types.length)];
      // let fonts = ['Inconsolata', 'Montserrat', 'Lato'];
      // let val7 = fonts[Math.floor(Math.random()*fonts.length)];
      // let fonts_sizes = ['14', '15', '16', '17', '18'];
      // let val8 = fonts_sizes[Math.floor(Math.random()*fonts_sizes.length)];
      // let avatar_shapes = ['none', 'circle', 'rect'];
      // let val9 = avatar_shapes[Math.floor(Math.random()*avatar_shapes.length)];
      // let styles = [
      //   '#hu-header { background-color: red; }',
      //   '#hu-header { background-color: transparent; }',
      //   '#hu-header { background-color: green; }', 
      // ];
      // let val10 = styles[Math.floor(Math.random()*styles.length)];
      // let colors = {
      //   header_text: val1,
      //   bot_message_background: val2,
      //   bot_message_text: val1,
      //   user_message_background: val1,
      //   user_message_text: val2,
      //   button_background: 'black',//val1,
      //   button_text: val2,
      //   textarea_background: val1,
      //   textarea_text: val2,
      //   textarea_border: val2,
      //   inline_input: val2,
      // };
      // let val12 = 'video';

      // this.setState({ gradient_from: val1, gradient_to: val2 });
      // this.setState({ accent: val1 });
      // this.setState({ background_color: val1, background_type: val3 });
      // this.setState({ background_image_url: val4 });
      // this.setState({ video_url: val5 });
      // console.log(val3, val5)
      // this.setState({ background_type: val12, videoname: val5 });
      // this.setState({ header_background: val1 });
      // this.setState({ background_type: val3, filter_type: val6 });
      // this.setState({ font: val7 });
      // this.setState({ font_size: val8 });
      // this.setState({tagline: val7});
      // this.setState({avatar_shape: val9});
      // this.setState({style: val10})
      // this.setState({ colors: colors });

    // }, 4000);

    // TESTS ==============================
  }

  render() {
    const { 
      isLoading,
      rendered,
      staticUrl,
      // Colors
      colors,
      accent,
      dark,
      light,
      contrast,
      header_background,
      // Avatar
      avatar_shape,
      avatar_scale,
      avatar_url,
      // Fonts
      font,
      font_size,
      // Content variables
      logo,
      brand_name,
      tagline,
      // Background variables
      background_type,
      background_image_url,
      background_color,
      gradient_from,
      gradient_to,
      videoname,
      video_url,
      // Filter variables
      filter_type,
      filter_color,
      filter_gradient_from,
      filter_gradient_to,
      filter_image_url,
      // External
      stylesheets,
      // Custom
      style,
      // Keywords
      keywords,
      persistent_menu,
      // Progress
      progress,
      // Test
      test,
      // Branding
      branding,
      // General syntax
      typing,
      widget_hide_background,
      widget_hide_header,
    } = this.state;

    return (
      <div id="app-modules" className={`${rendered ? 'rendered' : ''}`}>
        <DynamicStylesTag
          ee={ee}
          colors={colors}
          accent={accent}
          dark={dark}
          light={light}
          contrast={contrast}
          avatar_scale={avatar_scale}
          avatar_url={avatar_url}
          logo={logo}
          header_background={header_background}
          font={font}
          font_size={font_size}
          background_image_url={background_image_url}
          background_color={background_color}
          gradient_from={gradient_from}
          gradient_to={gradient_to}
          filter_color={filter_color}
          filter_gradient_from={filter_gradient_from}
          filter_gradient_to={filter_gradient_to}
          filter_image_url={filter_image_url}
          stylesheets={stylesheets}
          style={style}
        />
        <GUI
          ee={ee}
          staticUrl={staticUrl}
          isLoading={isLoading}
          avatar_shape={avatar_shape}
          brand_name={brand_name}
          logo={logo}
          brand_name={brand_name}
          tagline={tagline}
          keywords={keywords}
          persistent_menu={persistent_menu}
          progress={progress}
          test={test}
          branding={branding}
          typing={typing}
          widget_hide_header={widget_hide_header}
        />
        <Filter
          staticUrl={staticUrl}
          filter_type={filter_type}
          filter_color={filter_color}
          filter_gradient_from={filter_gradient_from}
          filter_gradient_to={filter_gradient_to}
          filter_image_url={filter_image_url}
          widget_hide_background={widget_hide_background}
        />
        <Background
          staticUrl={staticUrl}
          background_type={background_type}
          background_image_url={background_image_url}
          background_color={background_color}
          gradient_from={gradient_from}
          gradient_to={gradient_to}
          videoname={videoname}
          video_url={video_url}
          widget_hide_background={widget_hide_background}
        />
        <script src={`https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_API_KEY}&libraries=places`}></script>
      </div>
    );
  }
}

render(<App />, document.getElementById('app-landbot'));


/**
 * Module Hot Replacement
 * Determine actions made when code changes, instead of refreshing the whole page.
 */
if (module.hot) {
  // module.hot.accept();
}



// WEBPACK FOOTER //
// ./app/js/App.js